export default __webpack_public_path__ + "static/media/plus.792ec0c6.svg";